import { Button } from "flowbite-react";
import { deleteCollector } from "@/common/services/repossession.api";
import { useState } from "react";

interface FormRemoveCollectorProps {
    repossessionId: string;
    collectorId: string;
    onClose: () => void;
    onSuccess?: () => void;
}

export default function FormRemoveCollector({
    repossessionId,
    collectorId,
    onClose,
    onSuccess,
}: FormRemoveCollectorProps) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleConfirm = async () => {
        try {
            setLoading(true);
            setError(null);

            const res = await deleteCollector(repossessionId, collectorId);

            if (res.ok) {
                onSuccess?.();
                onClose();
            } else {
                setError(res.message || "Erro ao remover coletor.");
            }
        } catch (err) {
            console.error(err);
            setError("Erro inesperado ao remover coletor.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="text-center space-y-4">
            <h3 className="text-lg font-medium text-gray-900">
                Tem certeza que deseja remover o recolhedor?
            </h3>
            {error && <p className="text-red-500 text-sm">{error}</p>}

            <div className="flex justify-center gap-3">
                <Button color="gray" onClick={onClose}>
                    Cancelar
                </Button>
                <Button color="failure" onClick={handleConfirm} isProcessing={loading}>
                    Confirmar
                </Button>
            </div>
        </div>
    );
}
